import React from "react";
import { ENROLLMENT_PAGES } from "../../constants/enrollment";

const PageStepperItem = ({ pageNumber, pageNumberToDisplay, label, isActive, isCompleted, index }: { pageNumber: number, pageNumberToDisplay: string, label: string, isActive: boolean, isCompleted: boolean, index: number }) => {
  return (
    <li
      key={pageNumber}
    >
      <div className="flex-row justify-content-start align-items-center">
        <div className="flex-row">
          <div className={`step h-32 w-32 rounded-full border flex-row justify-content-center align-items-center bold font-size-lg  ${isActive ? "border-2 border-navy-blue text-white bg-navy-blue" : isCompleted ? "abyss-blue border-abyss-blue" : "shark-grey border-shark-grey"}`}>
            {pageNumberToDisplay}

          </div>
          <div className="flex-row justify-content-center align-items-center">
            <label className={`spacing-left-small font-size-lg abyss-blue bold mb-0 ${isActive || isCompleted ? "abyss-blue" : "shark-grey"}`}>
              {label}
            </label>
          </div>

        </div>
      </div>

      {index !== ENROLLMENT_PAGES.length - 1 &&
        <div className={`line w-32 h-6 flex-row justify-content-center align-items-center`}>
          <div className="w-1 h-full border border-gray-100"></div>
        </div>
      }
    </li>
  )
}

export default PageStepperItem;